import _ from "lodash";

import { Product, ProductKey } from "../";

/**
 * Check whether a signup is for BB/JSW
 */

export const getIsBundleBbJsw = (products: Product[]): boolean => {
    return (
        products.length === 2 &&
        _.includes(
            _.map(
                products,
                (val: Product) => val.product === ProductKey.JIRA_SOFTWARE
            ),
            true
        ) &&
        _.includes(
            _.map(
                products,
                (val: Product) => val.product === ProductKey.BITBUCKET
            ),
            true
        )
    );
};

/**
 * Check whether a signup is for BB
 */
export const getIsBitbucket = (products: Product[]): boolean => {
    return (
        products.length === 1 &&
        _.includes(
            _.map(products, (val) => val.product === ProductKey.BITBUCKET),
            true
        )
    );
};

/**
 * Check whether a signup is for Devops (JSW, Conf, BB, OG)
 */

export const getIsBundleDevops = (products: Product[]): boolean => {
    return (
        products.length === 4 &&
        _.includes(
            _.map(
                products,
                (val: Product) => val.product === ProductKey.JIRA_SOFTWARE
            ),
            true
        ) &&
        _.includes(
            _.map(
                products,
                (val: Product) => val.product === ProductKey.CONFLUENCE
            ),
            true
        ) &&
        _.includes(
            _.map(
                products,
                (val: Product) => val.product === ProductKey.BITBUCKET
            ),
            true
        ) &&
        _.includes(
            _.map(
                products,
                (val: Product) => val.product === ProductKey.OPSGENIE
            ),
            true
        )
    );
};
